export default "__VITE_ASSET__DI_k2Irw__"